import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DisableButtonOfflineDirective } from "./disable-button-offline.directive";

@NgModule({
    declarations: [DisableButtonOfflineDirective],
    imports: [CommonModule],
    exports: [DisableButtonOfflineDirective]
})
export class OfflineModule {}
